import React from 'react';

const Ex1_Model = () => {
    return (
        <div>Ex1_Model Component</div>
    );
}

export default Ex1_Model;
